<template>
  <div>
    <!--banner轮播-->
    <div class="swiper-container" id="mySwiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(banner, index) in bannerList" :key="index" >
          <img :src="banner.img" style="width: 100%;height: 600px;"/>
        </div>
      </div>
      <!-- 如果需要分页器 -->
      <div class="swiper-pagination"></div>

      <!-- 如果需要导航按钮 -->
      <div class="swiper-button-prev"></div>
      <div class="swiper-button-next"></div>
    </div>

    <!-- Search Area Starts -->
<!--    <div class="search-area">-->
<!--      <div class="search-bg">-->
<!--        <div class="container">-->
<!--          <div class="row">-->
<!--            <div class="col-lg-12">-->
<!--              <form action="#" class="d-md-flex justify-content-between">-->
<!--                <select>-->
<!--                  <option value="1">All Category</option>-->
<!--                  <option value="2">Part Time</option>-->
<!--                  <option value="3">Full Time</option>-->
<!--                  <option value="4">Remote</option>-->
<!--                  <option value="5">Office Job</option>-->
<!--                </select>-->
<!--                <select>-->
<!--                  <option value="1">Select Location</option>-->
<!--                  <option value="2">Dhaka</option>-->
<!--                  <option value="3">Rajshahi</option>-->
<!--                  <option value="4">Barishal</option>-->
<!--                  <option value="5">Noakhali</option>-->
<!--                </select>-->
<!--                <input type="text" placeholder="Search Keyword" onfocus="this.placeholder = ''"-->
<!--                       onblur="this.placeholder = 'Search Keyword'" required>-->
<!--                <button type="submit" class="template-btn">find job</button>-->
<!--              </form>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </div>-->
    <!-- Search Area End -->

    <!-- Feature Area Starts -->
    <section class="feature-area section-padding2" style="padding: 70px 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>我们能为您做什么</h2>
              <p>提供灵活用工智能结算和个税申报服务，定制各类金融系统、云计算平台开发</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4">
            <div class="single-feature mb-4 mb-lg-0" style="height: 400px;">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/101.png" alt="" style="width: -webkit-fill-available;height: 180px;">
              <h4 style="text-align: center;margin-top: 30px;">灵活用工</h4>
              <p class="py-3">
                针对兼职人员、自由职业者、薪资大幅波动人员以及平台型企业的税务解决</p>
<!--              <a href="#" class="secondary-btn">explore now<span class="flaticon-next"></span></a>-->
            </div>
          </div>
          <div class="col-lg-4" >
            <div class="single-feature mb-4 mb-lg-0" style="height: 400px;">
              <h4 style="text-align: center">解决佣金/工资发放繁琐</h4>
              <p class="py-3">
                批量一键算薪+薪资发放+完税一站式处理,节省人力成本,保障资金安全,并7*24小时实时到账</p>
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/102.png" alt="" style="width: -webkit-fill-available;height: 180px;">
<!--              <a href="#" class="secondary-btn">explore now<span class="flaticon-next"></span></a>-->
            </div>
          </div>
          <div class="col-lg-4" >
            <div class="single-feature" style="height: 400px;">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/103.png" alt="" style="width: -webkit-fill-available;height: 180px;">
              <h4 style="text-align: center;margin-top: 30px;">税务申报</h4>
              <p class="py-3">
                为灵活用工企业提供灵活就业合规税务申报服务以及企业的税务代征代缴服务，提高企业工作效率，降低企业成本、为企业合规发展保驾护航</p>
<!--              <a href="#" class="secondary-btn">explore now<span class="flaticon-next"></span></a>-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Area End -->

    <!-- Feature Area Starts -->
    <section class="feature-area section-padding2" style="padding: 70px 0;background: aliceblue;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>我们的优势</h2>
              <p>落实企业从注册落户到税收返还的各项事务</p>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <el-steps :active="4" align-center>
              <el-step title="0风险" icon="el-icon-lock" description="精准完税、国家政策地方法规、合法合规">
              </el-step>
              <el-step title="风控强" icon="el-icon-coordinate" description="严格控制企业业务管理注重风险控制"></el-step>
              <el-step title="选择多、覆盖广" icon="el-icon-magic-stick" description="与政府园区战略合作"></el-step>
              <el-step title="不操心" icon="el-icon-coin" description="B2C，C2B多形式服务资深财税专家团队7*24全天候服务"></el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Area End -->

    <!-- Category Area Starts -->
    <section class="category-area section-padding2" style="padding: 70px 0;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>服务行业展示</h2>
<!--              <p>Open lesser winged midst wherein may morning</p>-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center mb-4">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/104.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>外卖配送</h4>-->
              <h5>外卖配送</h5>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center mb-4">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/105.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>production & operation</h4>-->
              <h5>社交电商</h5>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center mb-4">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/106.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>telecommunication</h4>-->
              <h5>家政保洁</h5>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center mb-4">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/107.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>garments & textile</h4>-->
              <h5>快递物流</h5>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center mb-4 mb-lg-0">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/108.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>marketing and sales</h4>-->
              <h5>支付行业</h5>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center mb-4 mb-lg-0">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/109.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>engineer & architech</h4>-->
              <h5>在线教育</h5>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center mb-4 mb-md-0">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/110.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>design & crative</h4>-->
              <h5>文化传媒</h5>
            </div>
          </div>
          <div class="col-lg-3 col-md-6">
            <div class="single-category text-center">
              <img src="https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/111.jpg" alt="" style="width: 100%;height: 150px;">
<!--              <h4>customer support</h4>-->
              <h5>零售行业</h5>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Category Area End -->

    <!-- Feature Area Starts -->
    <section class="feature-area section-padding2" style="padding: 70px 0;background: aliceblue;">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="section-top text-center">
              <h2>合作流程</h2>
<!--              <p>落实企业从注册落户到税收返还的各项事务</p>-->
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-12">
            <el-steps :active="4" align-center>
              <el-step title="咨询税务老师"></el-step>
              <el-step title="根据企业业务制定方案"></el-step>
              <el-step title="签订协议"></el-step>
              <el-step title="享受服务"></el-step>
            </el-steps>
          </div>
        </div>
      </div>
    </section>
    <!-- Feature Area End -->

    <!-- Banner Area Starts -->
    <section class="banner-area section-padding">
      <div class="container-fluid">
        <div class="row">
          <div class="col-lg-6 px-0">
            <div class="banner-bg" style="width: 100%;margin: 40px;"></div>
          </div>
          <div class="col-lg-6 align-self-center">
            <div class="banner-text" style="padding: 0px 18% 0px 11%;">
              <h1>企业简介</h1>
              <p class="py-3">
                点金云是北京点金企服科技有限公司旗下专业的税筹平台，多年来一直致力于成为国内领先的财税服务平台，利用互联网、云计算、
                大数据等先进技术结合专业的财税领域知识，把过去高度依赖人员专业知识的税务筹划服务，封装成相对标准的节税产品。
                从而面向企业提供智能财税工具、财税知识培训、财税风控、合规增值等于一体的财税综合服务。</p>
              <router-link to="/elements" class="secondary-btn">查看更多<span class="flaticon-next"></span></router-link>
<!--              <a href="#" class="secondary-btn">查看更多<span class="flaticon-next"></span></a>-->
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- Banner Area End -->

    <!-- Jobs Area Starts -->
<!--    <section class="jobs-area section-padding3">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="jobs-title">-->
<!--              <h2>Browse recent jobs</h2>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="jobs-tab tab-item">-->
<!--              <ul class="nav nav-tabs" id="myTab" role="tablist">-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link active" id="home-tab" data-toggle="tab" href="#recent" role="tab"-->
<!--                     aria-controls="home" aria-selected="true">recent</a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link" id="profile-tab" data-toggle="tab" href="#full-time" role="tab"-->
<!--                     aria-controls="profile" aria-selected="false">full time</a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link" id="contact-tab" data-toggle="tab" href="#part-time" role="tab"-->
<!--                     aria-controls="part-time" aria-selected="false">part time</a>-->
<!--                </li>-->
<!--                <li class="nav-item">-->
<!--                  <a class="nav-link" id="contact-tab2" data-toggle="tab" href="#intern" role="tab"-->
<!--                     aria-controls="intern" aria-selected="false">intern</a>-->
<!--                </li>-->
<!--              </ul>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="tab-content" id="myTabContent">-->
<!--              <div class="tab-pane fade show active" id="recent" role="tabpanel" aria-labelledby="home-tab">-->
<!--                <div class="single-job mb-4 d-lg-flex justify-content-between">-->
<!--                  <div class="job-text">-->
<!--                    <h4>Assistant Executive - Production/ Quality Control</h4>-->
<!--                    <ul class="mt-4">-->
<!--                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>-->
<!--                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>-->
<!--                        Applied Chemistry & Chemical Engineering / Chemistry</h5></li>-->
<!--                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                  <div class="job-img align-self-center">-->
<!--                    <img src="static/assets/images/job1.png" alt="job">-->
<!--                  </div>-->
<!--                  <div class="job-btn align-self-center">-->
<!--                    <a href="#" class="third-btn job-btn1">full time</a>-->
<!--                    <a href="#" class="third-btn">apply</a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="tab-pane fade" id="full-time" role="tabpanel" aria-labelledby="profile-tab">-->
<!--                <div class="single-job mb-4 d-lg-flex justify-content-between">-->
<!--                  <div class="job-text">-->
<!--                    <h4>Asst. Manager, Production (Woven Dyeing)</h4>-->
<!--                    <ul class="mt-4">-->
<!--                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>-->
<!--                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>-->
<!--                        Applied Chemistry & Chemical Engineering / Chemistry</h5></li>-->
<!--                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                  <div class="job-img align-self-center">-->
<!--                    <img src="static/assets/images/job2.png" alt="job">-->
<!--                  </div>-->
<!--                  <div class="job-btn align-self-center">-->
<!--                    <a href="#" class="third-btn job-btn2">full time</a>-->
<!--                    <a href="#" class="third-btn">apply</a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="tab-pane fade" id="part-time" role="tabpanel" aria-labelledby="contact-tab">-->
<!--                <div class="single-job mb-4 d-lg-flex justify-content-between">-->
<!--                  <div class="job-text">-->
<!--                    <h4>Deputy Manager/ Assistant Manager - Footwear</h4>-->
<!--                    <ul class="mt-4">-->
<!--                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>-->
<!--                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>-->
<!--                        Applied Chemistry & Chemical Engineering / Chemistry</h5></li>-->
<!--                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                  <div class="job-img align-self-center">-->
<!--                    <img src="static/assets/images/job3.png" alt="job">-->
<!--                  </div>-->
<!--                  <div class="job-btn align-self-center">-->
<!--                    <a href="#" class="third-btn job-btn3">full time</a>-->
<!--                    <a href="#" class="third-btn">apply</a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="tab-pane fade" id="intern" role="tabpanel" aria-labelledby="contact-tab2s">-->
<!--                <div class="single-job mb-4 d-lg-flex justify-content-between">-->
<!--                  <div class="job-text">-->
<!--                    <h4>R&D Manager (Technical Lab Department)</h4>-->
<!--                    <ul class="mt-4">-->
<!--                      <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>-->
<!--                      <li class="mb-3"><h5><i class="fa fa-pie-chart"></i>-->
<!--                        Applied Chemistry & Chemical Engineering / Chemistry</h5></li>-->
<!--                      <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>-->
<!--                    </ul>-->
<!--                  </div>-->
<!--                  <div class="job-img align-self-center">-->
<!--                    <img src="static/assets/images/job4.png" alt="job">-->
<!--                  </div>-->
<!--                  <div class="job-btn align-self-center">-->
<!--                    <a href="#" class="third-btn job-btn4">full time</a>-->
<!--                    <a href="#" class="third-btn">apply</a>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--            &lt;!&ndash; <div class="single-job d-lg-flex justify-content-between">-->
<!--                <div class="job-text">-->
<!--                    <h4>Manager/ Asst. Manager (Quality Assurance)</h4>-->
<!--                    <ul class="mt-4">-->
<!--                        <li class="mb-3"><h5><i class="fa fa-map-marker"></i> new yourk, USA</h5></li>-->
<!--                        <li class="mb-3"><h5><i class="fa fa-pie-chart"></i> Applied Chemistry & Chemical Engineering / Chemistry</h5></li>-->
<!--                        <li><h5><i class="fa fa-clock-o"></i> Deadline Deadline: Dec 11, 2018</h5></li>-->
<!--                    </ul>-->
<!--                </div>-->
<!--                <div class="job-img align-self-center">-->
<!--                    <img src="static/assets/images/job5.png" alt="job">-->
<!--                </div>-->
<!--                <div class="job-btn align-self-center">-->
<!--                    <a href="#" class="third-btn job-btn2">full time</a>-->
<!--                    <a href="#" class="third-btn">apply</a>-->
<!--                </div>-->
<!--            </div> &ndash;&gt;-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="more-job-btn mt-5 text-center">-->
<!--          <a href="#" class="template-btn">more job post</a>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
<!--    &lt;!&ndash; Jobs Area End &ndash;&gt;-->

<!--    &lt;!&ndash; Newsletter Area Starts &ndash;&gt;-->
<!--    <section class="newsletter-area section-padding">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <h2>Get job information daily</h2>-->
<!--              <p>Subscribe to our newsletter and get a coupon code!</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <form action="#">-->
<!--              <input type="email" placeholder="Your email here" onfocus="this.placeholder = ''"-->
<!--                     onblur="this.placeholder = 'Your email here'" required>-->
<!--              <button type="submit" class="template-btn">subscribe now</button>-->
<!--            </form>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
<!--    &lt;!&ndash; Newsletter Area End &ndash;&gt;-->

<!--    &lt;!&ndash; Employee Area Starts &ndash;&gt;-->
<!--    <section class="employee-area section-padding">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <h2>Happy employee</h2>-->
<!--              <p>Open lesser winged midst wherein may morning</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="employee-slider owl-carousel">-->
<!--              <div class="single-slide d-sm-flex">-->
<!--                <div class="slide-img employee1">-->
<!--                  <div class="hover-state">-->
<!--                    <div class="hover-text text-center">-->
<!--                      <h3>david aron</h3>-->
<!--                      <h5>Facebook</h5>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="slide-text align-self-center">-->
<!--                  <i class="fa fa-quote-left"></i>-->
<!--                  <p>-->
<!--                    Appear, called day. Sixth two after eve moved called winged very heaven two lights let all third gathered.</p>-->
<!--                </div>-->
<!--              </div>-->
<!--              <div class="single-slide d-sm-flex">-->
<!--                <div class="slide-img employee2">-->
<!--                  <div class="hover-state">-->
<!--                    <div class="hover-text text-center">-->
<!--                      <h3>david aron</h3>-->
<!--                      <h5>Twitter</h5>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--                <div class="slide-text align-self-center">-->
<!--                  <i class="fa fa-quote-left"></i>-->
<!--                  <p>-->
<!--                    Appear, called day. Sixth two after eve moved called winged very heaven two lights let all third gathered.</p>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
<!--    &lt;!&ndash; Employee Area End &ndash;&gt;-->

<!--    &lt;!&ndash; News Area Starts &ndash;&gt;-->
<!--    <section id="blog" class="news-area section-padding3">-->
<!--      <div class="container">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-12">-->
<!--            <div class="section-top text-center">-->
<!--              <h2>Company latest news</h2>-->
<!--              <p>Open lesser winged midst wherein may morning</p>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--        <div class="row">-->
<!--          <div class="col-lg-4 col-md-6">-->
<!--            <div class="single-news mb-5 mb-lg-0">-->
<!--              <div class="news-img news-img1"></div>-->
<!--              <div class="news-tag">-->
<!--                <ul class="my-4">-->
<!--                  <li><h5><i class="fa fa-calendar-o"></i> 20th sep, 2018</h5></li>-->
<!--                  <li class="separator mx-2"><span></span></li>-->
<!--                  <li><h5><i class="fa fa-folder-open-o"></i> company</h5></li>-->
<!--                </ul>-->
<!--              </div>-->
<!--              <div class="news-title">-->
<!--                <h4><a href="#">Lime recalls electric scooters over battery fire.</a></h4>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-4 col-md-6">-->
<!--            <div class="single-news mb-5 mb-lg-0">-->
<!--              <div class="news-img news-img2"></div>-->
<!--              <div class="news-tag">-->
<!--                <ul class="my-4">-->
<!--                  <li><h5><i class="fa fa-calendar-o"></i> 18th sep, 2018</h5></li>-->
<!--                  <li class="separator mx-2"><span></span></li>-->
<!--                  <li><h5><i class="fa fa-folder-open-o"></i> company</h5></li>-->
<!--                </ul>-->
<!--              </div>-->
<!--              <div class="news-title">-->
<!--                <h4><a href="#">Apple resorts to promo deals trade to boost</a></h4>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-4 col-md-6">-->
<!--            <div class="single-news">-->
<!--              <div class="news-img news-img3"></div>-->
<!--              <div class="news-tag">-->
<!--                <ul class="my-4">-->
<!--                  <li><h5><i class="fa fa-calendar-o"></i> 25th sep, 2018</h5></li>-->
<!--                  <li class="separator mx-2"><span></span></li>-->
<!--                  <li><h5><i class="fa fa-folder-open-o"></i> company</h5></li>-->
<!--                </ul>-->
<!--              </div>-->
<!--              <div class="news-title">-->
<!--                <h4><a href="#">Lime recalls electric scooters over battery fire.</a></h4>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
<!--    &lt;!&ndash; News Area End &ndash;&gt;-->

<!--    &lt;!&ndash; Download Area Starts &ndash;&gt;-->
<!--    <section class="download-area section-padding">-->
<!--      <div class="container-fluid">-->
<!--        <div class="row">-->
<!--          <div class="col-lg-6">-->
<!--            <div class="download-text">-->
<!--              <h2>Download the app your mobile today</h2>-->
<!--              <p class="py-3">-->
<!--                Light earth also land can't. May you midst shall lights blessed in lights Have gathered image morning blessed grass him. Appear female rule all seas she'd winged</p>-->
<!--              <div class="download-button d-sm-flex flex-row justify-content-start">-->
<!--                <div class="download-btn mb-3 mb-sm-0 flex-row d-flex">-->
<!--                  <i class="fa fa-apple" aria-hidden="true"></i>-->
<!--                  <a href="#">-->
<!--                    <p>-->
<!--                      <span>Available</span> <br>-->
<!--                      on App Store-->
<!--                    </p>-->
<!--                  </a>-->
<!--                </div>-->
<!--                <div class="download-btn dark flex-row d-flex">-->
<!--                  <i class="fa fa-android" aria-hidden="true"></i>-->
<!--                  <a href="#">-->
<!--                    <p>-->
<!--                      <span>Available</span> <br>-->
<!--                      on Play Store-->
<!--                    </p>-->
<!--                  </a>-->
<!--                </div>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--          <div class="col-lg-6 pr-0">-->
<!--            <div class="download-img"></div>-->
<!--          </div>-->
<!--        </div>-->
<!--      </div>-->
<!--    </section>-->
    <!-- Download Area End -->
  </div>
</template>

<script>
import Swiper from 'swiper'

export default {

  components: {},

  props: {},

  data () {
    return {
      bannerList: [
        {
          img: 'https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/139.png'
        },
        {
          img: 'https://dianxingflex.oss-cn-beijing.aliyuncs.com/file/menhu/131.png'
        }
      ]
    }
  },
  watch: {
    banner: {
      handler (newBanner, oldBanner) {
        // 只能监听到轮播图数据已经有了，但是v-for动态渲染结构我们还是没有办法确定的，因此还是需要用nextTick
        // nextTick:  在下次 DOM 更新循环结束之后执行延迟回调。在修改数据之后立即使用这个方法，获取更新后的 DOM
        this.$nextTick(() => {
          // eslint-disable-next-line no-undef,no-unused-vars
          const mySwiper = new Swiper('.swiper-container', {
            loop: true, // 循环模式选项
            // 如果需要分页器
            pagination: {
              el: '.swiper-pagination',
              // 点击小球的时候也切换图片
              clickable: true
            },
            // 如果需要前进后退按钮
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev'
            },
            // 如果需要滚动条
            scrollbar: {
              el: '.swiper-scrollbar'
            }
          })
        })
      },
      // 立即监听：不管你数据有没有变化，我上来立即监听一次
      immediate: true
    }
  }
}
</script>

<style>
.el-step.is-center .el-step__description{
  margin-top: 40px;
  font-size: 14px;
  color: rgba(0, 0, 0, 1);
}
.el-step__icon.is-icon{
  background: aliceblue;
}

</style>



// WEBPACK FOOTER //
// src/pages/Home.vue